import { Skeleton } from "components/ui/skeleton";

export default function UserProfileSkeleton() {
  return (
    <div className="border-b-4">
      <div className="flex flex-col items-center w-full">
        <div className="relative mb-24">
          <Skeleton className="rounded-b-3xl w-full h-[200px] sm:h-[300px] md:h-[400px] aspect-[16/9]" />
          <Skeleton className="absolute -bottom-16 left-[39%] rounded-full w-[140px] h-[140px] border-4" />
        </div>
        <div className="space-y-4 mb-4 mt-0.5">
          <Skeleton className="h-6 w-[500px]" />
          <Skeleton className="h-6 w-[500px]" />
          <Skeleton className="h-6 w-[500px]" />
          <Skeleton className="h-6 w-[500px]" />
          <div className="flex justify-center items-center space-x-3 ">
            <Skeleton className="h-8 w-[50px]" />
            <Skeleton className="h-8 w-[50px]" />
            <Skeleton className="h-8 w-[50px]" />
            <Skeleton className="h-8 w-[50px]" />
            <Skeleton className="h-8 w-[50px]" />
            <Skeleton className="h-8 w-[50px]" />
            <Skeleton className="h-8 w-[50px]" />
          </div>
        </div>
      </div>
    </div>
  );
}
